import { Component, OnInit } from '@angular/core';
import { RequestService } from '../../../services/request.service';
import { PortalNotificationDto } from '../../../model/notification/portal-notification-dto';
import { SnackService } from '../../../services/snack.service';
import { StringHelper } from '../../../helpers/string-helper';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-portal-config',
  templateUrl: './client-portal-config.component.html',
  styleUrls: ['./client-portal-config.component.scss'],
})
export class ClientPortalConfigComponent implements OnInit {
  portalNotification: PortalNotificationDto;
  loading = true;

  constructor(
    private requestService: RequestService,
    private snackService: SnackService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.requestService.getNormal('/portalnotification/home.info').subscribe(
      (response: PortalNotificationDto) => {
        this.portalNotification = response;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  savePortalNotification(): void {
    //validate if text input is empty
    if (StringHelper.isEmpty(this.portalNotification.text)) {
      this.snackService.showError('Set a banner text, please');
      return;
    }

    this.requestService
      .put(this.portalNotification, '/portalnotification')
      .subscribe((value) => {
        this.snackService.showSuccess('Configuratie succesvol opgeslagen');
        this.router.navigate(['/projecten']);
      });
  }
}
